import { getAppCta } from './navigation';
import type { FeatureBlockContent, HeroContent, ProviderLogo } from './types';

export const cryptoProviders: ProviderLogo[] = [
  { name: 'Binance', src: '/images/stablecoin/providers/binance.png' },
  { name: 'Coinbase', src: '/images/stablecoin/providers/coinbase.png' },
  { name: 'Kraken', src: '/images/stablecoin/providers/kraken.png' },
  { name: 'MEXC', src: '/images/stablecoin/providers/mexc.png' },
  { name: 'Crypto.com', src: '/images/stablecoin/providers/crypto-com.png' },
  { name: '+56', src: '/images/stablecoin/providers/more.png' },
];

export const cryptoHero: HeroContent = {
  title: 'Convert between Stablecoin and USD',
  cta: getAppCta,
  image: {
    src: '/images/stablecoin/hero.jpg',
    alt: 'nsave app on a phone showing the list of supported stablecoin wallets and providers',
  },
};

export const cryptoDeposit: FeatureBlockContent = {
  title: 'Deposit via Stablecoin',
  image: {
    src: '/images/stablecoin/convert.jpg',
    alt: 'USDC being converted into your nsave USD balance',
  },
  rows: [
    {
      icon: 'download',
      title: 'Deposit from any major exchange',
      description:
        'Send USDC, USDT and more directly from Binance, Coinbase, Kraken and dozens of others straight to your nsave wallet.',
    },
    {
      icon: 'swap',
      title: 'Automatic conversion to USD',
      description:
        'Your stablecoin is instantly converted to USD and credited to your nsave balance, ready to spend or save.',
    },
    {
      icon: 'bitcoin',
      title: 'USDC & USDT on Solana',
      description:
        'Send funds directly from your Solana wallet. Low fees, fast confirmation, credited in minutes.',
    },
  ],
};

export const cryptoSend: FeatureBlockContent = {
  title: 'Send funds to your\nStablecoin Wallet',
  image: {
    src: '/images/stablecoin/providers.jpg',
    alt: 'Choosing a stablecoin wallet or provider in the nsave app',
  },
  rows: [
    {
      icon: 'upload',
      title: 'Send to any stablecoin wallet',
      description:
        'Transfer funds to any external stablecoin wallet address. Simple, fast and fully in your control.',
    },
    {
      icon: 'coin',
      title: 'Choose your provider',
      description:
        'Withdraw to Binance, Coinbase, Kraken, MEXC, Crypto.com and 50+ more supported wallets and providers.',
    },
  ],
};
